<!--
 * @Descripttion: 
 * @Author: zhanghang
 * @Date: 2023-08-10 14:10:28
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-08-10 15:04:35
-->
<template>
  <div :ref="ref" class="dataview-select-lines">
    <svg :width="realWidth" :height="realHeight">
      <defs>
        <marker id="arrow" markerUnits="strokeWidth" markerWidth="12" markerHeight="12" viewBox="0 0 12 12" refX="6" refY="6" orient="auto">
          <path xmlns="http://www.w3.org/2000/svg" d="M2,2 L10,6 L2,10 L6,6 L2,2" style="fill: red;" />
        </marker>
      </defs>
      <line
        v-for="(it, index) in lines"
        :key="index"
        :x1="it.start.x"
        :y1="it.start.y"
        :x2="it.end.x"
        :y2="it.end.y"
        stroke="red"
        marker-end="url(#arrow)"
        stroke-width="2"
        stroke-dasharray="10,10"
      ></line>
    </svg>
  </div>
</template>
<script>
export default {
  name: "DesSelectLines",
  props: {
    originLines: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      ref: "box",
      realWidth: 0,
      realHeight: 0,
      lines: [],
    };
  },
  watch: {
    originLines: {
      handler() {
      this.initLines()
      },
      immediate:true
    },
  },
  mounted() {
    this.realWidth = this.$refs.box.clientWidth;
    this.realHeight = this.$refs.box.clientHeight;
  },
  methods: {
    initLines() {
      let originLines = [...this.originLines];
      let start = originLines.shift();
      let lines = [];
      originLines.forEach((end) => {
        lines.push({
          start,
          end,
        });
      });
      this.lines = lines;
    },
  },
};
</script>
